/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCipher from './AqaCipher';

/**
 * The Store model module.
 * @module model/Store
 * @version v0
 */
export default class Store {
  /**
   * Constructs a new <code>Store</code>.
   * @alias module:model/Store
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Store</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Store} obj Optional instance to populate.
   * @return {module:model/Store} The populated <code>Store</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Store();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('cipher'))
        obj.cipher = AqaCipher.constructFromObject(data['cipher']);
      if (data.hasOwnProperty('encrypted'))
        obj.encrypted = ApiClient.convertToType(data['encrypted'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Store.prototype.id = undefined;

/**
 * @member {module:model/AqaCipher} cipher
 */
Store.prototype.cipher = undefined;

/**
 * @member {Boolean} encrypted
 */
Store.prototype.encrypted = undefined;

